import React from 'react';
import { Body, Box } from '@hover/blueprint';
import type { IFaqQuestion } from '../interfaces/IFaqQuestion';
import type { IRoofingMaterial } from '../interfaces/IRoofingMaterial';

export const VINYL_SIDING_ESTIMATOR_FAQ: Array<IFaqQuestion> = [
  {
    id: 0,
    title: 'Why is it important to get accurate siding measurements?',
    content: (
      <Body mb={500}>
        Accurate siding measurements help exterior home improvement
        professionals and homeowners more accurately estimate the quantity of
        required materials and the cost of the job. With accurate measurements,
        contractors won’t have to buy more materials mid-job (or figure out what
        to do with unused materials) – saving time and money for both pros and
        homeowners.
      </Body>
    ),
  },
  {
    id: 1,
    title: 'Is there an alternative to manually measuring my house for siding?',
    content: (
      <Box mb={500}>
        Yes! The HOVER app will do all the complicated work for you. Download
        the app, take some home photos, and in hours, not days, we’ll deliver
        accurate measurements to contractors and share the home’s interactive 3D
        model with homeowners and contractors. No ladders, no tape measures, no
        math formulas needed.
      </Box>
    ),
  },
  {
    id: 2,
    title: 'Why should I use HOVER to measure for siding?',
    content: (
      <Body mb={500}>
        HOVER saves professionals hours taking measurements at the job site and
        calculating quotes in the office, and it’ll save homeowners time in
        getting their project planning started. The to-scale virtual 3D model
        allows pros and homeowners to design and visualize the project before
        it’s built. HOVER’s accurate measurements eliminate manual data entry or
        calculations and the need to re-measure.
      </Body>
    ),
  },
  {
    id: 3,
    title: 'What are some other benefits of using HOVER?',
    content: (
      <Box mb={500}>
        HOVER makes collaboration possible. All members of the team (sales,
        production, installation, etc.) and the homeowner can be on the same
        page from planning to installation. Resources can be allocated more
        efficiently and work can be completed on time and on budget.
      </Box>
    ),
  },
  {
    id: 4,
    title: 'How does HOVER work?',
    content: (
      <Box mb={500}>
        Just snap photos of the exterior of any house with the HOVER app and
        we’ll use our patented technology to calculate square footage and linear
        measurements for roof, siding, windows, trim and more. We’ll also build
        an interactive 3D model to help homeowners and pros design projects
        together. But HOVER is more than just a siding calculator and 3D model.
        Professionals use HOVER’s platform to estimate jobs, create proposals
        and contracts, and order directly from suppliers.
      </Box>
    ),
  },
];

export const SIDING_MATERIALS: Array<IRoofingMaterial> = [
  {
    id: 0,
    title: 'VINYL',
    body: 'Vinyl siding is a great choice for most homes. It’s low-cost, durable, looks beautiful and the time needed to install it is minimal. So, this is an excellent option for homeowners working with a budget. The cost of vinyl siding is as low as $2 per square foot.',
  },
  {
    id: 1,
    title: 'WOOD',
    body: 'Wood is beautiful but comes at a higher price and requires periodic maintenance. Wood siding costs can range up to $10 per square foot, not to mention additional costs for staining. This is a great option for homeowners on a larger budget.',
  },
  {
    id: 2,
    title: 'STUCCO',
    body: 'Stucco is one of the highest cost options at upwards of $30 per square foot, but if well maintained it will last a lifetime. Extra care should be taken when applying Stucco to avoid cracks. The durability is great for homeowners who plan to stay in their home for a long time.',
  },
];
